import { Image as ImageIcon, Trash2, X } from 'lucide-react';
import type { EditorImageToolsProps } from '../hooks/useEditorImages';
import { ImageGroupModal } from './ImageGroupModal';

// Verborgen file-inputs en de twee bewerkvensters; de werkbalkknoppen staan in het scherm zelf.
export function EditorImageTools({
  editor,
  fileInputRef,
  groupFileInputRef,
  onImageFiles,
  onGroupFiles,
  imageModal,
  setImageAlt,
  setImageCaption,
  onImageSave,
  onImageRemove,
  onImageClose,
  imageGroupPos,
  onGroupClose,
  onGroupAddFiles,
}: EditorImageToolsProps) {
  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => {
          const files = Array.from(e.target.files ?? []);
          onImageFiles(files);
          e.target.value = '';
        }}
      />
      <input
        ref={groupFileInputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => {
          const files = Array.from(e.target.files ?? []);
          onGroupFiles(files);
          e.target.value = '';
        }}
      />
      {imageModal.open && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-[#231F20] flex items-center gap-2">
                <ImageIcon className="w-5 h-5 text-[#FF6B35]" />
                Afbeelding bewerken
              </h2>
              <button
                onClick={() => onImageClose()}
                className="p-1.5 rounded hover:bg-gray-100 transition-colors text-gray-500"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-6 py-5 space-y-4">
              {imageModal.src && (
                <img
                  src={imageModal.src}
                  alt=""
                  className="max-h-40 w-full object-contain rounded-lg bg-gray-50 border border-gray-200"
                />
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Alt-tekst
                </label>
                <input
                  type="text"
                  value={imageModal.alt}
                  onChange={(e) => setImageAlt(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') onImageSave(); if (e.key === 'Escape') onImageClose(); }}
                  className="input-field"
                  placeholder="Korte omschrijving van de afbeelding"
                  autoFocus
                />
                <p className="mt-1 text-xs text-gray-500">
                  Voor zoekmachines en voorleessoftware. Niet zichtbaar op je blog.
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Bijschrift
                </label>
                <input
                  type="text"
                  value={imageModal.caption}
                  onChange={(e) => setImageCaption(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') onImageSave(); if (e.key === 'Escape') onImageClose(); }}
                  className="input-field"
                  placeholder="Tekst onder de afbeelding (optioneel)"
                />
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between gap-3">
              <button
                onClick={onImageRemove}
                className="flex items-center gap-1.5 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <Trash2 className="w-4 h-4" />
                Verwijderen
              </button>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onImageClose()}
                  className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  Annuleren
                </button>
                <button
                  onClick={onImageSave}
                  className="px-4 py-2 text-sm font-medium bg-[#FF6B35] text-white rounded-lg hover:bg-[#E55A2B] transition-colors"
                >
                  Opslaan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {editor && imageGroupPos !== null && (
        <ImageGroupModal
          key={imageGroupPos}
          editor={editor}
          groupPos={imageGroupPos}
          onClose={onGroupClose}
          onAddFiles={onGroupAddFiles}
        />
      )}
    </>
  );
}
